import Standard from './Standard';

const V3 = {
  Standard,
};

export default V3;
